import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lista-pagos',
  templateUrl: './lista-pagos.component.html',
  styleUrls: ['./lista-pagos.component.css']
})
export class ListaPagosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
